var render = function render(){
  var _vm$selectedData, _vm$selectedData$post;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return (_vm$selectedData = _vm.selectedData) !== null && _vm$selectedData !== void 0 && (_vm$selectedData$post = _vm$selectedData.postpones) !== null && _vm$selectedData$post !== void 0 && _vm$selectedData$post.length ? _c('table', {
    staticClass: "table table-striped mb-0 mt-3"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.selectedData.postpones, function (postpone, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "font-semibold text-black"
    }, [_vm._v(_vm._s(_vm.formatDate(postpone.extra_date)))]), _c('td', {
      staticClass: "font-semibold text-black"
    }, [_vm._v(_vm._s(_vm.formatHours(postpone.extra_hours)) + " Hours")]), _c('td', {
      staticClass: "font-semibold text-black"
    }, [_vm._v(_vm._s(postpone.reason))])]);
  }), 0)]) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('th', [_vm._v("Postponed Date")]), _c('th', [_vm._v("Postponed (RH)")]), _c('th', [_vm._v("Postponed Notes")])]);

}]

export { render, staticRenderFns }